import React from 'react';
import VisuallyHidden from '@atlaskit/visually-hidden';
import Content from '../shared/content';
import IconRenderer from '../shared/icon-renderer';
import useButtonBase from '../shared/use-button-base';
/**
 * __Use icon button__
 *
 * A React hook that accepts a set of icon Button props,
 * and processes them to return consistent base props for usage
 * across IconButton and LinkIconButton variants.
 *
 * @private
 */
const useIconButton = ({
  analyticsContext,
  appearance,
  ariaLabel,
  ariaLabelledBy,
  autoFocus,
  buttonType,
  icon,
  interactionName,
  isDisabled,
  isLoading = false,
  isSelected,
  label,
  onClick,
  onClickCapture,
  onKeyDownCapture,
  onKeyUpCapture,
  onMouseDownCapture,
  onMouseUpCapture,
  onPointerDownCapture,
  onPointerUpCapture,
  onTouchEndCapture,
  onTouchStartCapture,
  ref,
  shape,
  shouldFitContainer,
  spacing,
  testId,
  UNSAFE_size
}) => {
  const isCircle = shape === 'circle';
  const baseProps = useButtonBase({
    analyticsContext,
    appearance,
    autoFocus,
    ariaLabel,
    ariaLabelledBy,
    buttonType,
    children: /*#__PURE__*/React.createElement(Content, {
      type: "icon",
      isLoading: isLoading
    }, /*#__PURE__*/React.createElement(IconRenderer, {
      icon: icon,
      size: UNSAFE_size
    }), /*#__PURE__*/React.createElement(VisuallyHidden, null, label)),
    interactionName,
    isDisabled,
    isLoading,
    isSelected,
    isIconButton: true,
    isCircle,
    onClick,
    onMouseDownCapture,
    onMouseUpCapture,
    onKeyDownCapture,
    onKeyUpCapture,
    onTouchStartCapture,
    onTouchEndCapture,
    onPointerDownCapture,
    onPointerUpCapture,
    onClickCapture,
    ref,
    shouldFitContainer,
    spacing,
    testId
  });
  return baseProps;
};
export default useIconButton;